import { useContext } from 'react';
import { useTheme } from '@mui/material';
import { Context } from './CreateNotice';
import ReceiverSelectDialog from './ReceiverSelectDialog';
import PreviewDialog from './PreviewDialog';

import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import FormLabel from '@mui/material/FormLabel';
import Button from '@mui/material/Button';

const CreateNoticeHeader = (props) => {
  const { palette, typography } = useTheme();
  const styles = {
    selectButton: {
      ...typography.body16,
      width: '240px',
      height: '44px',
      justifyContent: 'start',
      borderColor: 'rgba(0, 0, 0, 0.25)',
    },
    previewAllButton: {
      ...typography.body14bold,
      display: 'flex',
      width: '192px',
      height: '44px',
      padding: '0px 16px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      margin: '0px 8px 0px 8px',

      borderRadius: '100px',
      border: '1px solid ' + palette.primary.light,
      background: palette.white,
      color: palette.primary.light,
    },
    sendAllNotificationsButton: {
      ...typography.body14bold,
      'width': '192px',
      'height': '44px',
      'justifyContent': 'center',
      'alignItems': 'center',
      'gap': '8px',
      'margin': '0px 0px 0px 8px',

      'borderRadius': '100px',
      'border': '1px solid ' + palette.primary.light,
      'background': palette.primary.light,
      'color': palette.white,
      '&:hover': {
        width: '192px',
        height: '44px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        margin: '0px 0px 0px 8px',
        borderRadius: '100px',
        border: '1px solid ' + palette.primary.light,
        background: palette.primary.light,
        color: palette.white,
      },
      '&:disabled': {
        ...typography.body14bold,
        border: '1px solid ' + palette.disabledCccccc,
        color: palette.white,
        background: palette.disabledCccccc,
      },
    },
  };

  const {
    receivers,
    setOpenSelectReceiver,
    setOpenPreview,
    handleSubmit,
    isDisable,
  } = useContext(Context);

  const getReceiversName = () => {
    const receiversNames = receivers.map((v) => v.name);
    if (receiversNames.length === 0) {
      return null;
    }
    if (receiversNames.length === 1) {
      return receiversNames[0];
    }
    return receiversNames[0] + `, 他${receiversNames.length - 1}名`;
  };

  return (
    <>
      <Stack
        bgcolor='white'
        borderBottom={`1px solid ${palette.divider}`}
        direction='row'
        alignItems='flex-end'
        padding='16px 0px'
      >
        <Container sx={{ display: 'flex', alignItems: 'flex-end' }}>
          <Stack direction='column' spacing={1}>
            <FormLabel required sx={typography.caption13bold} >
              送信先
            </FormLabel>
            <Button
              variant='outlined' color="secondary" sx={styles.selectButton}
              onClick={() => {
                setOpenSelectReceiver(true);
              }}
            >
              {getReceiversName() || '選択する'}
            </Button>
          </Stack>
          <Stack direction={'row'} sx={{ width: 'fit-content', padding: 'auto 0px 0px 0px', margin: '0px 0px 0px auto' }}>
            <Button variant="outlined"
              sx={styles.previewAllButton}
              disabled={isDisable()}
              onClick={() => {
                setOpenPreview({ isOpen: true, index: null });
              }}
            >
              <p>プレビューを確認する</p>
            </Button>
            <Button variant="filled"
              sx={styles.sendAllNotificationsButton}
              disabled={isDisable()}
              onClick={() => {
                handleSubmit(null);
              }}
            >
              <p>全て送信する</p>
            </Button>
          </Stack>
        </Container>
      </Stack>

      {/* 送信先選択ダイアログ */}
      < ReceiverSelectDialog />
      {/* プレビューダイアログ */}
      < PreviewDialog />
    </>
  );
};

export default CreateNoticeHeader;
